// extracted by mini-css-extract-plugin
export default {"pixelNumber":"PixelNumber_pixelNumber__gmn5D","svgCharacter":"PixelNumber_svgCharacter__fVUqd"};